import { PagedRequestType, PagedResultsType } from "../../../types/PagedResults";
import { get } from "../../../utils/axios-config";
import { ENROLLMENT_REQUIRED_DOCUMENTS } from "../../../utils/constants";
import { EnrollmentRequiredDocumentType } from "../../../types/EnrollmentRequiredDocument";

export const getEnrollmentRequiredDocuments = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100'
    });
    const url = `${ENROLLMENT_REQUIRED_DOCUMENTS}?${queryParams.toString()}`;
    return await get<PagedResultsType<EnrollmentRequiredDocumentType>>(url)
};